import { render, staticRenderFns } from "./NeueDozentenbuchungModal.vue?vue&type=template&id=176ebbad"
import script from "./NeueDozentenbuchungModal.vue?vue&type=script&lang=js"
export * from "./NeueDozentenbuchungModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports